import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useStoreActions } from "easy-peasy";
import { parse } from "query-string";
import { signInWithGooglePopup } from "../lib/google-oauth";
import { authenticateWithGoogle } from "../api/google-auth";
import { notifyError } from "../lib/notifications";
import { redirectAfterLogin } from "../lib/redirect-after-login";
import {
  saveRedirectParams,
  clearRedirectParams,
  saveDoorkeeperParamsFromUrl,
} from "../lib/oauth-redirect-storage";
import { GoogleIcon } from "./GoogleIcon";
import { LoadingSpinner } from "./LoadingSpinner";
import { SecondaryButton } from "./SecondaryButton";

export const SignInWithGoogle = () => {
  const [isLoading, setIsLoading] = useState(false);
  const history = useHistory();
  const setIsAuthenticated = useStoreActions(
    (actions) => actions.setIsAuthenticated,
  );

  const handleSignIn = async () => {
    try {
      setIsLoading(true);

      const queries = parse(window.location.search);
      const { redirect_app } = queries;

      if (redirect_app) {
        saveRedirectParams(queries);
      } else {
        clearRedirectParams();
      }

      // If we're on /oauth/authorize (the Doorkeeper / ELMO flow), stash the
      // Doorkeeper params so we can resume the OAuth handshake after the
      // social sign-in round-trip. No-op for the plain /login flow.
      saveDoorkeeperParamsFromUrl();

      const { code, codeVerifier } = await signInWithGooglePopup();
      await authenticateWithGoogle({ code, codeVerifier });

      setIsAuthenticated(true);
      redirectAfterLogin(history);
    } catch (error) {
      console.error("Google sign-in error:", error);

      if (error.response?.data?.error === "account_not_connected") {
        history.push("/account-not-connected");
      } else if (error.message === "Authentication cancelled") {
        setIsLoading(false);
      } else {
        notifyError(
          error.response?.data?.message ||
            error.message ||
            "Failed to sign in with Google. Please try again.",
        );
        setIsLoading(false);
      }
    }
  };

  return (
    <SecondaryButton
      onClick={handleSignIn}
      disabled={isLoading}
      className="mb-2 w-full py-3 flex items-center justify-center"
    >
      {isLoading ? (
        <>
          <LoadingSpinner className="h-5 w-5" />
          Signing in...
        </>
      ) : (
        <>
          <GoogleIcon className="w-5 h-5" />
          Sign in with Google
        </>
      )}
    </SecondaryButton>
  );
};
